import { authApiIdempotent } from '../firebase/config.js';
import { ENV } from '../config/env.js';

const API_BASE_URL = ENV.apiBaseUrl;

// Word/PowerPoint/Excel — routed through /convert-document-to-pdf (isolated LibreOffice
// service) so they render in the same pdf.js document-study modal PDFs already use, images
// and layout included. PDFs themselves never match this — they need no conversion.
const OFFICE_MIME_RE = /^application\/(msword|vnd\.openxmlformats-officedocument\.|vnd\.ms-(word|powerpoint|excel))/i;
export const isOfficeFile = (file) => !!file?.type && OFFICE_MIME_RE.test(file.type);

function fileToBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
            try { resolve(String(reader.result).split(',')[1]); } catch (err) { reject(err); }
        };
        reader.onerror = () => reject(reader.error || new Error('Failed to read file'));
        reader.readAsDataURL(file);
    });
}

function base64ToBytes(base64) {
    const binary = atob(base64);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
    return bytes;
}

// Converts a Word/PowerPoint/Excel File to a PDF File the document-study modal can open
// exactly like a native PDF upload.
export async function convertOfficeFileToPdf(file) {
    const base64 = await fileToBase64(file);
    const data = await authApiIdempotent(`${API_BASE_URL}/convert-document-to-pdf`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ document_data: base64, mime_type: file.type, fileName: file.name }),
    });
    const pdfBytes = base64ToBytes(data.pdf_data);
    const pdfName = file.name.replace(/\.[a-z0-9]+$/i, '') + '.pdf';
    return new File([pdfBytes], pdfName, { type: 'application/pdf' });
}
